import {computed, reactive} from 'vue';
import DrafterSearch from '@/core/model/drafter-search';

interface searchState {
    data: DrafterSearch | null;
}

const state = reactive<searchState>({
    data: null
});

export default function useCurrentSearch() {
    const setNewSearch = (search: DrafterSearch) => {
        state.data = search
    };

    const currentSearch = computed(() => {
        if (state.data === null) {
            return new DrafterSearch();
        }

        return state.data;
    });

    const noResultSearch = computed(() => {
        if (state.data && state.data.classes.length === 0) {
            return true;
        }

        return false;
    });

    const haveSearched = computed(() => {
        if (state.data === null) {
            return false;
        }

        return true;
    });


    return { setNewSearch, currentSearch, noResultSearch, haveSearched };
}
